import {
  fallbackCopy,
  newAnswerAreaPinComponent,
  newImagePinComponent,
  newSize,
  newTextPinComponent,
  newVector,
} from '../helpers';
import { ImagePinComponent, OpenQuestionPinLayoutTemplate } from '../models';
import { stringToProsemirror } from '../tip-tap';

export function openQuestionTitleOnlyLayout({
  question = fallbackCopy['openQuestion.title'],
  backgroundColor,
  backgroundImage,
}: {
  question?: string;
  backgroundColor?: string;
  backgroundImage?: string;
}): OpenQuestionPinLayoutTemplate {
  return {
    key: 'TITLE_ONLY',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      TITLE: newTextPinComponent({
        position: newVector(32, 32),
        size: newSize(896, 60),
        content: stringToProsemirror(question, {
          bold: true,
        }),
        order: 'a0',
        settings: {
          typographyKey: 'headline',
          textStyleKey: 'TITLE',
          horizontalAlignment: 'center',
        },
      }),
      ANSWER_AREA: newAnswerAreaPinComponent({
        order: 'a1',
      }),
    },
    pinComponents: [],
  };
}

export function openQuestionQuestionLeftWithImageLayout({
  question = fallbackCopy['openQuestion.title'],
  backgroundColor,
  backgroundImage,
  imageOverride,
}: {
  question?: string;
  backgroundColor?: string;
  backgroundImage?: string;
  imageOverride?: ImagePinComponent | 'no-image';
}): OpenQuestionPinLayoutTemplate {
  return {
    key: 'IMAGE_LEFT',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      TITLE: newTextPinComponent({
        position: newVector(32, 32),
        size: newSize(432, 222),
        content: stringToProsemirror(question, {
          bold: true,
        }),
        order: 'a0',
        settings: {
          typographyKey: 'headline',
          textStyleKey: 'TITLE',
          horizontalAlignment: 'center',
        },
      }),
      ...(imageOverride !== 'no-image' && {
        IMAGE1:
          imageOverride ||
          newImagePinComponent({
            position: newVector(32, 286),
            size: newSize(432, 222),
            order: 'a1',
          }),
      }),

      ANSWER_AREA: newAnswerAreaPinComponent({
        position: newVector(496, 32),
        size: newSize(432, 476),
        order: 'a2',
      }),
    },
    pinComponents: [],
  };
}

export function openQuestionQuestionRightWithImageLayout({
  question = fallbackCopy['openQuestion.title'],
  backgroundColor,
  backgroundImage,
  imageOverride,
}: {
  question?: string;
  backgroundColor?: string;
  backgroundImage?: string;
  imageOverride?: ImagePinComponent | 'no-image';
}): OpenQuestionPinLayoutTemplate {
  return {
    key: 'IMAGE_RIGHT',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      TITLE: newTextPinComponent({
        position: newVector(496, 32),
        size: newSize(432, 222),
        content: stringToProsemirror(question, {
          bold: true,
        }),
        order: 'a0',
        settings: {
          typographyKey: 'headline',
          textStyleKey: 'TITLE',
          horizontalAlignment: 'center',
        },
      }),

      ...(imageOverride !== 'no-image' && {
        IMAGE1:
          imageOverride ||
          newImagePinComponent({
            position: newVector(496, 286),
            size: newSize(432, 222),
            order: 'a1',
          }),
      }),
      ANSWER_AREA: newAnswerAreaPinComponent({
        position: newVector(32, 32),
        size: newSize(432, 476),
        order: 'a2',
      }),
    },
    pinComponents: [],
  };
}

export function openQuestionImageOnlyLayout({
  imageOverride,
  backgroundColor,
  backgroundImage,
}: {
  imageOverride?: ImagePinComponent | 'no-image';
  backgroundColor?: string;
  backgroundImage?: string;
} = {}): OpenQuestionPinLayoutTemplate {
  return {
    key: 'IMAGE_ONLY',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      ...(imageOverride !== 'no-image' && {
        IMAGE1:
          imageOverride ||
          newImagePinComponent({
            position: newVector(32, 32),
            size: newSize(896, 170),
            order: 'a0',
          }),
      }),
      ANSWER_AREA: newAnswerAreaPinComponent({
        order: 'a1',
        position: newVector(32, 236),
        size: newSize(896, 276),
      }),
    },
    pinComponents: [],
  };
}

export function openQuestionEmptyLayout({
  backgroundColor,
  backgroundImage,
}: {
  backgroundColor?: string;
  backgroundImage?: string;
} = {}): OpenQuestionPinLayoutTemplate {
  return {
    key: 'EMPTY',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      ANSWER_AREA: newAnswerAreaPinComponent({
        order: 'a1',
        position: newVector(32, 32),
        size: newSize(896, 476),
      }),
    },
    pinComponents: [],
  };
}
